
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { EnumCityStatus } from '@xt/client/entities/kindred-spirit/guild'
import type { ConfirmModalOptions, CityTypeInfo, AllCities } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import InitConfirmModal from '../InitConfirmModal/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import CityCard from '../CityCard/index.vue'
import CityFilterModal from './CityFilterModal/index.vue'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { Observer } from 'mobx-vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status'

@Observer
@Component({
  components: {
    CityCard,
    InitConfirmModal,
    LazyImg,
    CityFilterModal,
    EmptyStatus
  }
})
export default class CityListGird extends Vue {
  @Prop({ default: 0 }) marginTop!: number
  @Prop({ default: false }) hasJoin: boolean
  @Prop({ default: null }) localCity: CityTypeInfo | null
  @Prop({ default: () => [] }) recommendCities: Array<CityTypeInfo>
  @Prop({ default: () => [] }) allCities: Array<AllCities>
  @Prop({ default: false }) isLocalLoading: boolean

  @Ref()
  initConfirmModal: {
    show: (options?: ConfirmModalOptions) => Promise<boolean>
    hide: () => void
  }

  @Ref()
  cityFilterModal: {
    show: () => Promise<boolean>
    hide: () => void
  }

  get isCityListPage() {
    return this.$route.name === 'topic-city-list'
  }

  get notEmptyProvince() {
    const target = this.allCities.find(i => i.parent.adcode === this.select)
    return !!target?.list?.length
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get body() {
    return {
      statusArr: [EnumCityStatus.Assistance, EnumCityStatus.Inited].join(',')
    }
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get TonghaoStore() {
    return this.$store.$tonghao
  }

  get GuildStore() {
    return this.$store.$tonghao.Guild
  }

  async handleConfirm(data: number[] | null) {
    if (!data || !data.length || data.length <= 1) {
      this.$message.warn('请选择城市')
      return
    }

    const res = await this.GuildStore.createGuild(data[1])

    if (res === true) {
      this.$message.success('创建成功')

      await this.GuildStore.getHasJoinedCity()

      if (!this.GuildStore.joinedCity) return

      this.$emit('init-success', this.GuildStore.joinedCity.id)
    }
  }

  async handleShowInit() {
    if (!this.UserInfo.id) {
      this.$emit('unauthorized')
      return
    }

    this.initConfirmModal.show()
  }

  handleToCityPage(cityId: number) {
    if (!cityId) return

    if (this.$route.name === 'topic') {
      window.open(`/topic/city/${cityId}`, '_blank')
      return
    }

    this.$router.push({
      path: `/topic/city/${cityId}`
    })
  }

  // 筛选弹窗显示
  handleShowFilterModal() {
    this.cityFilterModal.show()
  }

  select: string = ''

  // 筛选页面分桐数据
  onFilterPage(select?: string) {
    this.select = select ?? ''

    const el = document.querySelector('#dynamic-grid')

    if (!el) return

    const { height } = el.getBoundingClientRect()
    const restTop = this.isCityListPage ? 807 : 434

    window.scrollTo({ top: Math.floor(height) + restTop, behavior: 'smooth' })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
